
import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ProviderManager } from "@/components/api-integration/ProviderManager";
import { UserConnections } from "@/components/api-integration/UserConnections";
import { ApiTester } from "@/components/api-integration/ApiTester";
import { useAuth } from "@/hooks/useAuth";
import { useUserRoles } from "@/hooks/useUserRoles";
import { Navigate } from "react-router-dom";
import { Shell } from "@/components/layout/Shell";

export default function ApiIntegrationPage() {
  const [activeTab, setActiveTab] = useState("connections");
  const { user } = useAuth();
  const { useHasRoleQuery } = useUserRoles();
  const { data: isAdmin } = useHasRoleQuery("ADMIN");
  const { data: isDeveloper } = useHasRoleQuery("DEVELOPER");
  
  const hasAdminAccess = isAdmin || isDeveloper;

  // Redirect if not admin
  if (!hasAdminAccess) {
    return <Navigate to="/admin" replace />;
  }

  return (
    <Shell className="p-4 md:p-6">
      <h1 className="text-3xl font-bold mb-6">API Integrations</h1>
      
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="mb-4">
          <TabsTrigger value="providers">Manage Providers</TabsTrigger>
          <TabsTrigger value="connections">User Connections</TabsTrigger>
          <TabsTrigger value="test">Test API</TabsTrigger>
        </TabsList>

        <TabsContent value="providers" className="py-4">
          <ProviderManager />
        </TabsContent>

        <TabsContent value="connections" className="py-4">
          <UserConnections />
        </TabsContent>

        <TabsContent value="test" className="py-4">
          <ApiTester />
        </TabsContent>
      </Tabs>
    </Shell>
  );
}
